import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { FileUpload } from "primereact/fileupload";
import { ProgressBar } from "primereact/progressbar";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import SupplierService from "../../services/SupplierService";

export default function SupplierImportPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
  const [importing, setImporting] = useState(false);
  const [result, setResult] = useState(null);
  const [stagedFile, setStagedFile] = useState(null);
  const toast = useRef(null);
  const navigate = useNavigate();
  const fileUploadRef = useRef(null);

      const openFileDialog = () => {
        fileUploadRef.current?.getInput()?.click();
    };

  const onDownloadSample = async () => {
    try {
      const response = await SupplierService.downloadSample();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "tedarikci_import_sablon.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: "Örnek dosya indirilemedi!",
      });
    }
  };

  const onSelect = (e) => {
    setStagedFile(e.files[0]);
  };

  const onClear = () => {
    setStagedFile(null);
    if (fileUploadRef.current) {
        fileUploadRef.current.clear();
    }
  };

  const handleImportClick = () => {
    if (!stagedFile) return;

    confirmDialog({
      message: "Tedarikçiler otomatik olarak kaydedilecektir onaylıyor musunuz?",
      header: "İçe Aktarma Onayı",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Evet, Başlat",
      rejectLabel: "Vazgeç",
      className: "rounded-2xl",
      acceptClassName: "p-button-success rounded-xl font-bold px-4",
      rejectClassName: "p-button-text text-slate-500 rounded-xl px-4",
      accept: () => processUpload(),
    });
  };

  const processUpload = async () => {
    const formData = new FormData();
    formData.append("file", stagedFile);

    setImporting(true);
    setResult(null);

    try {
      const res = await SupplierService.importExcel(formData);
      const data = res.data?.data || res.data;

      setResult(data);

      if (data.successCount > 0 || data.updatedCount > 0) {
        if (data.errorCount > 0) {
          toast.current.show({
            severity: "warn",
            summary: "Kısmi Başarı",
            detail: `${data.successCount} yeni tedarikçi eklendi, ${data.updatedCount} tedarikçi güncellendi. ${data.errorCount} tedarikçide hata oluştu.`,
            life: 6000
          });
        } else {
          toast.current.show({
            severity: "success",
            summary: "İşlem Başarılı",
            detail: `${data.successCount} yeni tedarikçi eklendi, ${data.updatedCount} tedarikçi güncellendi.`,
            life: 5000
          });
        }
      } else if (data.errorCount > 0) {
        toast.current.show({
          severity: "error",
          summary: "İçe Aktarma Başarısız",
          detail: `Tüm tedarikçilerde (${data.errorCount} adet) hata oluştu.`,
          life: 5000
        });
      }
      setStagedFile(null);
      if (fileUploadRef.current) {
          fileUploadRef.current.clear();
      }
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: err.response?.data?.message || "İçe aktarma sırasında bir hata oluştu!",
      });
    } finally {
      setImporting(false);
    }
  };

    const emptyTemplate = () => {
        return (
            <div
                onClick={openFileDialog}
                className="flex flex-col items-center justify-center p-8 md:p-12 border-2 border-dashed border-slate-200 rounded-3xl bg-slate-50/30 hover:bg-blue-50/30 hover:border-blue-300 transition-all cursor-pointer group"
            >
                <div className="w-16 h-16 bg-white rounded-2xl shadow-sm border border-slate-100 flex items-center justify-center mb-4 group-hover:scale-105 group-hover:shadow-md transition-all">
                    <i className="pi pi-cloud-upload text-blue-500 text-2xl"></i>
                </div>

                <h2 className="text-slate-800 font-black text-xl mb-1 text-center tracking-tight">
                    Excel Dosyasını Buraya Bırakın
                </h2>

                <p className="text-slate-400 text-xs text-center font-bold">
                    veya dosya seçmek için bu alana tıklayın
                </p>

                <div className="mt-5 flex items-center gap-3">
                    <span className="px-2.5 py-1 bg-white border border-slate-100 rounded-lg text-[9px] font-black text-slate-400 uppercase tracking-widest shadow-sm">
                        .XLSX
                    </span>
                    <span className="px-2.5 py-1 bg-white border border-slate-100 rounded-lg text-[9px] font-black text-slate-400 uppercase tracking-widest shadow-sm">
                        MAX 10MB
                    </span>
                </div>
            </div>
        );
    };


  return (
    <div className="p-4 md:p-5 bg-[#f8fafc] min-h-screen font-inter animate-fade-in">
      <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />
      <ConfirmDialog />

      <div className="max-w-5xl mx-auto space-y-5">

        {/* Elite Header */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl !bg-blue-600 flex items-center justify-center shadow-lg shadow-blue-200/50">
                    <i className="pi pi-building text-white text-xl" />
                </div>
                <div>
                    <h1 className="text-2xl md:text-3xl font-black text-slate-900 leading-tight tracking-tighter uppercase">Tedarikçi İçe Aktar</h1>
                    <div className="flex items-center gap-2.5 mt-0.5">
                        <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
                        <p className="text-slate-500 font-bold text-[11px] uppercase tracking-widest">Excel Veri Entegrasyonu</p>
                    </div>
                </div>
            </div>

            <Button
              label="TEDARİKÇİ LİSTESİ"
              icon="pi pi-arrow-left"
              className="p-button-text text-slate-400 font-black text-xs hover:bg-white hover:shadow-sm rounded-xl px-4 py-2.5 transition-all"
              onClick={() => navigate("/suppliers")}
            />
        </div>

        {/* Process Visualizer */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {[
                { step: "01", title: "Şablonu Hazırla", desc: "Verilerinizi şablona uygun hale getirin.", color: "bg-blue-50 border-blue-100", iconColor: "text-blue-600", icon: "pi-file-edit", shadow: "shadow-blue-500/5" },
                { step: "02", title: "Dosyayı Yükle", desc: "Hazırladığınız dosyayı sisteme yükleyin.", color: "bg-amber-50 border-amber-100", iconColor: "text-amber-600", icon: "pi-upload", shadow: "shadow-amber-500/5" },
                { step: "03", title: "İşlemi Tamamla", desc: "Onay verin ve saniyeler içinde kaydedin.", color: "bg-emerald-50 border-emerald-100", iconColor: "text-emerald-600", icon: "pi-check-circle", shadow: "shadow-emerald-500/5" }
            ].map((s, i) => (
                <div key={i} className={`${s.color} p-4 rounded-2xl border shadow-sm ${s.shadow} flex items-center gap-4 transition-all hover:scale-[1.01]`}>
                    <div className="flex flex-col items-center justify-center min-w-[40px]">
                        <i className={`pi ${s.icon} ${s.iconColor} text-xl mb-0.5`} />
                        <span className={`text-[9px] font-black ${s.iconColor} opacity-50 uppercase`}>Adım {s.step}</span>
                    </div>
                    <div className="w-px h-8 bg-slate-200 opacity-50" />
                    <div>
                        <h4 className="font-black text-slate-800 text-xs uppercase tracking-tight">{s.title}</h4>
                        <p className="text-[10px] text-slate-500 font-bold leading-normal">{s.desc}</p>
                    </div>
                </div>
            ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

            {/* Main Upload Zone */}
            <div className="lg:col-span-8 space-y-4">
                <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl blur opacity-5 group-hover:opacity-10 transition duration-1000 group-hover:duration-200" />
                    <Card className="rounded-3xl border-none shadow-lg shadow-slate-200/40 overflow-hidden relative bg-white">
                        <div className="p-5">
                            <FileUpload
                                ref={fileUploadRef}
                                name="file"
                                accept=".xlsx"
                                maxFileSize={10000000}
                                customUpload
                                onSelect={onSelect}
                                onClear={onClear}
                                mode="advanced"
                                headerStyle={{ display: 'none' }}
                                contentStyle={{ border: 'none', padding: 0 }}
                                emptyTemplate={emptyTemplate}
                                disabled={importing}
                            />

                            {stagedFile && !importing && (
                                <div className="mt-5 animate-slide-up">
                                    <div className="bg-blue-50 border border-blue-100 rounded-2xl p-4 flex items-center justify-between">
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-sm">
                                                <i className="pi pi-file-excel text-blue-500 text-lg" />
                                            </div>
                                            <div>
                                                <p className="text-slate-800 font-black text-xs uppercase tracking-tight">{stagedFile.name}</p>
                                                <p className="text-slate-400 text-[9px] font-bold">{(stagedFile.size / 1024).toFixed(1)} KB • Yüklemeye Hazır</p>
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <Button
                                                icon="pi pi-times"
                                                className="p-button-rounded p-button-text p-button-danger !h-8 !w-8"
                                                onClick={onClear}
                                                tooltip="Dosyayı Kaldır"
                                            />
                                            <Button
                                                label="İÇE AKTARMAYI BAŞLAT"
                                                icon="pi pi-check"
                                                className="!bg-blue-600 border-none rounded-xl px-4 py-2 font-black text-[9px] shadow-md shadow-blue-200 transition-all active:scale-95"
                                                onClick={handleImportClick}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {importing && (
                                <div className="mt-8 space-y-4 text-center">
                                    <div className="flex flex-col items-center gap-3">
                                        <div className="relative">
                                            <div className="w-14 h-14 rounded-full border-4 border-slate-50 border-t-indigo-600 animate-spin" />
                                            <div className="absolute inset-0 flex items-center justify-center">
                                                <i className="pi pi-bolt text-indigo-600 animate-pulse text-sm" />
                                            </div>
                                        </div>
                                        <div>
                                            <h3 className="text-lg font-black text-slate-800 uppercase tracking-tighter">İşlem Yapılıyor</h3>
                                            <p className="text-slate-400 text-[10px] font-bold mt-0.5">LÜTFEN PENCEREYİ KAPATMAYIN...</p>
                                        </div>
                                    </div>
                                    <ProgressBar mode="indeterminate" style={{ height: '4px', borderRadius: '10px' }} color="#6366f1" />
                                </div>
                            )}
                        </div>
                    </Card>
                </div>

                {/* Enhanced Results Section */}
                {result && (
                  <div className="animate-slide-up bg-white p-5 rounded-3xl border border-slate-100 shadow-lg shadow-slate-200/40 space-y-6">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-xl bg-slate-50 text-slate-600 flex items-center justify-center">
                                <i className="pi pi-chart-bar text-lg" />
                            </div>
                            <div>
                                <h3 className="font-black text-slate-800 uppercase tracking-tighter text-sm">İşlem Özeti</h3>
                                <p className="text-slate-400 text-[9px] font-bold">VERİ ENTEGRASYONU TAMAMLANDI</p>
                            </div>
                        </div>
                        <Tag value="TAMAMLANDI" className="!bg-emerald-500 !text-white rounded-full px-4 py-1.5 font-black text-[9px] border-none shadow-md shadow-emerald-100" />
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      {[
                        { label: "Toplam", value: result.totalCount, color: "text-slate-600", bg: "bg-slate-50", icon: "pi-list" },
                        { label: "Yeni Kayıt", value: result.successCount, color: "text-emerald-600", bg: "bg-emerald-50", icon: "pi-plus-circle" },
                        { label: "Güncellenen", value: result.updatedCount, color: "text-blue-600", bg: "bg-blue-50", icon: "pi-refresh" },
                        { label: "Hatalı", value: result.errorCount, color: "text-rose-600", bg: "bg-rose-50", icon: "pi-times-circle" },
                      ].map((item, i) => (
                        <div key={i} className={`p-4 rounded-2xl ${item.bg} flex flex-col items-center text-center group transition-all hover:scale-105`}>
                            <div className={`w-8 h-8 rounded-lg bg-white shadow-sm flex items-center justify-center mb-3 ${item.color}`}>
                                <i className={`pi ${item.icon} text-sm`} />
                            </div>
                            <span className={`text-[8px] ${item.color} font-black uppercase tracking-widest mb-0.5`}>{item.label}</span>
                            <div className={`text-2xl font-black ${item.color} tracking-tighter`}>{item.value}</div>
                        </div>
                      ))}
                    </div>

                    {result.errors && result.errors.length > 0 && (
                      <div className="bg-rose-50/30 rounded-2xl p-5 border border-rose-100/50">
                        <div className="flex items-center gap-2 mb-4">
                            <i className="pi pi-exclamation-circle text-rose-500 text-lg" />
                            <span className="text-[10px] font-black text-rose-600 uppercase tracking-widest">Tespit Edilen Hatalar ({result.errors.length})</span>
                        </div>
                        <div className="space-y-2.5 max-h-48 overflow-y-auto pr-4 custom-scrollbar">
                            {result.errors.map((err, idx) => (
                              <div key={idx} className="bg-white/80 backdrop-blur-sm border border-rose-100 p-3 rounded-xl shadow-sm">
                                <p className="text-rose-700 text-[10px] font-bold leading-relaxed">{err}</p>
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
            </div>

            {/* Elite Sidebar */}
            <div className="lg:col-span-4 space-y-6">
                <Card className="rounded-3xl border-none shadow-lg shadow-slate-200/40 overflow-hidden bg-white p-2">
                    <div className="space-y-6">
                        <div className="flex flex-col items-center text-center px-2">
                            <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center mb-4 mt-2">
                                <i className="pi pi-download text-xl" />
                            </div>
                            <h3 className="font-black text-slate-800 uppercase tracking-tighter text-lg mb-2">Şablon Hazırlığı</h3>
                            <p className="text-slate-400 text-xs font-medium leading-relaxed">
                                Hızlı ve hatasız bir aktarım için sistemimize özel hazırlanan Excel şablonunu kullanın.
                            </p>
                        </div>

                        <div className="bg-slate-50/50 rounded-2xl p-4 space-y-3">
                            <div className="flex items-center gap-2.5 text-slate-500">
                                <i className="pi pi-check-circle text-emerald-500" />
                                <span className="text-[9px] font-black uppercase tracking-wider">Otomatik Kayıt Eşleme</span>
                            </div>
                            <div className="flex items-center gap-2.5 text-slate-500">
                                <i className="pi pi-check-circle text-emerald-500" />
                                <span className="text-[9px] font-black uppercase tracking-wider">Mükerrer Kayıt Koruması</span>
                            </div>
                            <div className="flex items-center gap-2.5 text-slate-500">
                                <i className="pi pi-check-circle text-emerald-500" />
                                <span className="text-[9px] font-black uppercase tracking-wider">Toplu Bilgi Güncelleme</span>
                            </div>
                        </div>

                        <Button
                            label="ÖRNEK DOSYAYI İNDİR"
                            icon="pi pi-file-export"
                            className="w-full !bg-slate-900 border-none hover:!bg-black rounded-xl py-3 font-black text-xs shadow-md shadow-slate-200 transition-all active:scale-95 mb-2"
                            onClick={onDownloadSample}
                        />
                    </div>
                </Card>

            </div>
        </div>
      </div>
    </div>
  );
}
